import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useValue } from '../context/ContextProvider';

const OkCancelDialog = () => {
  const { state: { okCancelDialog }, dispatch } = useValue();

  const {open, funcion, callerData} = okCancelDialog;

  const handleClose = (respuesta) => {
    if(respuesta === true) {
      //funcion();
      funcion({resp: 'ACEPTAR', callerData});
    } else {
      funcion({resp: 'CANCELAR', callerData});
    }  
    dispatch({ type: 'UPDATE_OKCANCEL', payload: { open: false, title: '', message: '', respuesta: {respuesta}, callerData: {callerData}} });
  };

    return (
      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {okCancelDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {okCancelDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancelar</Button>
          <Button onClick={() => handleClose(true)} autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default OkCancelDialog;